<template>
  <div class="defaultLayout">
    <in-header />
    <div class="container">
      <in-nav :currentMenu="currentMenu" />
      <in-main :currentMenu="currentMenu" />
    </div>
    <loading></loading>
  </div>
</template>

<script>
import InHeader from "@/components/main/header";
import InNav from "@/components/main/Nav";
import InMain from "@/components/main/Main";
import Loading from "@/components/common/Loading.vue";

export default {
  name: "DefaultLayout",
  components: {
    Loading,
    InHeader,
    InNav,
    InMain
  },
  data() {
    return {
      menuList: [],
      currentMenu: {
        isActive: true,
        parent: {},
        child: {}
      }
    };
  }
};
</script>

<style scoped>
.container {
  display: flex;
  height: 100%;
  width: 100%;
}
</style>
